import dayjs from "dayjs";
import enUS from "rc-picker/lib/locale/en_US";
import esMX from "rc-picker/lib/locale/es_MX";
import ptBR from "rc-picker/lib/locale/pt_BR";
import Store from "store/store-config";
import { languageOptions } from "utils/functions";
import useTranslation from "utils/hooks/useTranslation";

export const getOptions = () => {
  const TODAY = useTranslation({ id: "today" });
  const MONTH = useTranslation({ id: "month" });
  const YESTERDAY = useTranslation({ id: "yesterday" });
  const options = {};
  options[TODAY] = [dayjs(), dayjs()];
  options[MONTH] = [dayjs().startOf("month"), dayjs().endOf("month")];
  options[YESTERDAY] = [dayjs().add(-1, "day"), dayjs().add(-1, "day")];
  return options;
};

export const rangeConfig = () => {
  const MESSAGE = useTranslation({ id: "required_field" });
  return {
    rules: [
      {
        required: true,
        message: MESSAGE,
      },
    ],
  };
};

export const translateDatePicker = () => {
  let locale = Store.getState().UserSession?.userData?.acceptLanguage || languageOptions[0].description;
  switch (locale) {
    case "en-US":
      locale = enUS;
      break;
    case "es-MX":
      locale = esMX;
      break;
    default:
      locale = ptBR;
      break;
  }
  return {
    lang: locale,
    timePickerLocale: locale,
  };
};
